import axios from 'axios';
import { commonConfiguration } from 'io/API';
import { onRequestError } from 'io/API/errorHandling';
import { setCookie } from 'utils/cookies';

const signUpUser = async (userData, contextConfiguration) => {
	try {
		const response = await axios.post(
			'/sign-up/',
			{
				email: userData.email,
				full_name: userData.voor_en_achternaam,
				password1: userData.password,
				password2: userData.password
			},
			{
				...commonConfiguration,
				...contextConfiguration,
				headers: {
					'Content-Type': 'application/json',
					'X-Requested-With': 'XMLHttpRequest',
				},
			}
		);

		return response;
	} catch (error) {
		if (error.response) {
			// Pass through the error response from the server
			throw error;
		}
		throw error;
	}
};

export default signUpUser;
